import React from 'react';
import PropTypes from 'prop-types';

import { Heading, Text } from '../Elements';

import classes from './PageTitle.module.scss';

const PageTitle = ({ title, subTitle, className }) => {
  return (
    <>
      <Heading className={className} size={1}>
        {title}
      </Heading>
      {subTitle && <Text className={classes.subtitle}>{subTitle}</Text>}
    </>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  subTitle: PropTypes.string
};

export default PageTitle;
